import { render, staticRenderFns } from "./newTraining.vue?vue&type=template&id=43e0c620&scoped=true&"
import script from "./newTraining.vue?vue&type=script&lang=js&"
export * from "./newTraining.vue?vue&type=script&lang=js&"
import style0 from "./newTraining.vue?vue&type=style&index=0&id=43e0c620&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e0c620",
  null
  
)

export default component.exports